import Icon from "./Icon";
import * as React from "react";
import { Button, Dropdown, DropdownButton, MenuItem } from "react-bootstrap";
function sharedStart(...input) {
    const inputArrs = input.map((iter) => iter.split(" "));
    const diffIdx = inputArrs[0].findIndex((iter, idx) => inputArrs.find((comp) => comp[idx] !== iter) !== undefined);
    return inputArrs[0].slice(0, diffIdx).join(" ");
}
class ToolbarDropdownItem extends React.PureComponent {
    render() {
        const { t, icon } = this.props;
        return React.createElement(MenuItem, { onSelect: this.invoke }, t(icon.title));
    }
    invoke = () => {
        const { icon, instanceIds } = this.props;
        icon.action(instanceIds);
    };
}
class ToolbarDropdown extends React.PureComponent {
    render() {
        const { t, className, icons, id, instanceId } = this.props;
        let classes = ["toolbar-dropdown"];
        if (className !== undefined) {
            classes = classes.concat(className.split(" "));
        }
        const shared = sharedStart(...icons.map((icon) => icon.title || ""));
        const def = icons.find((i) => i.default);
        const renderIcon = (icon) => (React.createElement(ToolbarDropdownItem, { t: t, key: icon.title, icon: icon, instanceIds: instanceId }));
        if (def !== undefined) {
            return (React.createElement(Dropdown, { id: id, className: classes.join(" ") },
                React.createElement(Button, { onClick: this.invokeDefault, className: "toolbar-dropdown-splitbtn" }, this.renderTitle(shared)),
                React.createElement(Dropdown.Toggle, null),
                React.createElement(Dropdown.Menu, null, icons.map(renderIcon))));
        }
        else {
            return (React.createElement(DropdownButton, { id: id, className: classes.join(" "), title: this.renderTitle(shared) }, icons.map(renderIcon)));
        }
    }
    renderTitle(shared) {
        const { t, icons, buttonType } = this.props;
        const hasIcon = buttonType === undefined ||
            ["icon", "both", "menu"].indexOf(buttonType) !== -1;
        const hasText = buttonType === undefined ||
            ["text", "both", "menu"].indexOf(buttonType) !== -1;
        return (React.createElement("div", null,
            hasIcon ? React.createElement(Icon, { name: icons[0].icon }) : null,
            hasText ? React.createElement("div", { className: "button-text" },
                t(shared),
                "...") : null));
    }
    invokeDefault = () => {
        const { icons, instanceId } = this.props;
        const def = icons.find((i) => i.default);
        if (def !== undefined) {
            def.action(instanceId);
        }
    };
}
export default ToolbarDropdown;
